import img1 from '../images/avani/avani_plus_riverside_bangkok_hotel_103_lobbyb.webp';
import img2 from '../images/avani/avani_plus_riverside_bangkok_hotel_19_the-cornerc.webp';
import img3 from '../images/avani/avani_plus_riverside_bangkok_hotel_1_front_desk_countera.webp';
import img4 from '../images/avani/avani_plus_riverside_bangkok_hotel_89_lobby-sitting-area-1200x760d.webp';

export const avaniImages = [img1, img2, img3, img4];
